import { SxProps, Theme } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { Link } from "react-router-dom";

const CRMButton = ({
  url,
  sx,
  size = "medium",
}: {
  url: string;
  sx?: SxProps<Theme>;
  size?: "small" | "medium";
}) => {
  return (
    <Link to={url} target="_blank">
      <IconButton size={size} aria-label="crm-quote" color="onSurface" sx={sx}>
        <Box
          component="img"
          src="/crmIcon.png"
          sx={{
            width: size === "small" ? "16px" : "24px",
            height: size === "small" ? "16px" : "24px",
          }}
        ></Box>
      </IconButton>
    </Link>
  );
};

export default CRMButton;
